if (document.readyState === 'loading') {
	document.addEventListener(
		'DOMContentLoaded',
		aa('init', {
			appId: process.env.ALGOLIA_APP_ID,
			apiKey: process.env.ALGOLIA_SEARCH_API_KEY,
		})
	);
} else {
	aa('init', {
		appId: process.env.ALGOLIA_APP_ID,
		apiKey: process.env.ALGOLIA_SEARCH_API_KEY,
	});
}
